
export const pageSearch = {
  
}

export default {
  'reward_id': {
    title: '项目类型编码',
    type: 'input',
  },
  'reward_name': {
    title: '项目类型描述',
    type: 'input',
    width: '200'
  },
  'reward_short': {
    title: '项目类型简称',
    type: 'input',
    width: '200'
  },
  'product_id': {
    title: '产品编码',
    type: 'dialog',
    dialog: {
      component: 'ProductSelect',
      title: '产品编码'
    }
  },
  'product_name': {
    title: '产品名称',
    type: 'input',
  },
  'pro_control': {
    title: '产品控制',
    describe: true,
    type: 'select',
    dictionary: 'A0078'
  },
  'start_date': {
    title: '有效期起',
    type: 'date',
    valueFormat: 'yyyy-MM-dd'
  },
  'end_date': {
    title: '有效期止',
    type: 'date',
    valueFormat: 'yyyy-MM-dd'
  },
  'quota_ratio': {
    title: '额度比例(%)',
  },
  'status': {
    title: '状态',
    slot: true,
    describe: true,
    type: 'select',
    dictionary: 'A0080'
  },
  'remark': {
    title: '备注',
  },
}



// WEBPACK FOOTER //
// ./src/views/reward-policy/config/rewardProject.js